import axios from "axios";
const serverHost = process.env.REACT_APP_REPORT_SERVER_URL;

export const login = async function login(username, password) {
    let accessToken = "";

    try {
        const response = await axios.post(
            serverHost + "/Token",
            `grant_type=password&username=${encodeURIComponent(
                username
            )}&password=${encodeURIComponent(password)}`,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        accessToken = response.data.access_token;
    } catch (error) {
        window.alert(error.response.status + ": " + error.response.data.error);
    }

    return accessToken;
};

//Based on https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value/4760279#4760279
export const dynamicSort = function (property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
};

export const dynamicSortMultiple = function () {
    var props = arguments;
    return function (obj1, obj2) {
        var i = 0,
            result = 0,
            numberOfProperties = props.length;
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i])(obj1, obj2);
            i++;
        }
        return result;
    };
};
